import React from 'react';
import { useInput } from 'react-admin';
import { CapabilitiesForm } from './CapabilitiesForm';

interface CapabilitiesInputProps {
    source: string;
    disabled?: boolean;
}

export const CapabilitiesInput: React.FC<CapabilitiesInputProps> = ({ source, disabled }) => {
    const {
        field,
    } = useInput({ source });

    // Parse the capabilities if it's a string
    const capabilities = React.useMemo(() => {
        if (typeof field.value === 'string') {
            try {
                return JSON.parse(field.value);
            } catch {
                return {};
            }
        }
        return field.value || {};
    }, [field.value]);

    const handleChange = (newCapabilities: any) => {
        field.onChange(newCapabilities);
    };

    return (
        <CapabilitiesForm
            capabilities={capabilities}
            onChange={handleChange}
            disabled={disabled}
        />
    );
};